import { Component, OnInit } from '@angular/core'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { CheckoutService } from '../../checkout.service'

@Component({
  standalone: false,
  // tslint:disable-next-line:component-selector
  selector: 'vs-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit {
  getDetailsForOrderNotifications: any
  public cartOrderReviewObj: any

  constructor(
    private checkoutService: CheckoutService,
    private globalMessageService: GlobalMessageService
  ) {}

  ngOnInit(): void {
    this.checkoutService.addressObjData.subscribe(
      (data) => {
        this.cartOrderReviewObj = data
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  convertFileRetain(data) {
    let returnVal
    returnVal = (data / (1024 * 1024)).toFixed(2)
    if (returnVal > 1) {
      return returnVal + 'mb'
    } else {
      return (data / 1024).toFixed(2) + 'kb'
    }
  }
}
